import type { UserType, UserTypeShort } from '@econtractor/types';

/** Короткий користувач шаблону → значення UserSelected */
export const templateUserToForm = (user?: UserTypeShort | null): UserType | null => {
    if (!user?.ID) return null;
    return {
        ID: user.ID,
        userName: user.userName || '',
        userEmail: user.userEmail || '',
        userPicture: user.userPicture || '',
        userStatus: 1,
        admin: 0,
        userMaster: 0,
        telegram: null,
        telegramEvents: {},
        telegramId: null,
        access: user.access ?? null,
        info: null,
        teamName: user.teamName,
    };
};
